import { render, staticRenderFns } from "./ProfilePrivatePhotos.vue?vue&type=template&id=56165759&"
import script from "./ProfilePrivatePhotos.vue?vue&type=script&lang=js&"
export * from "./ProfilePrivatePhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports